import { IconButton, Typography } from '@branch-messenger/willow-ui'
import { ArrowNarrowLeft, X } from '@branch-messenger/willow-ui/icons'

import {
  titles,
  useTakeAdvance,
} from '@/containers/onDemandPay/TakeAdvance/TakeAdvanceContext'

import { TakeAdvanceHeaderContainer } from './styles'

export const TakeAdvanceHeader = () => {
  const { backStep, close, currentStep } = useTakeAdvance()
  const showBackButton = currentStep !== 'AdvanceDestination'

  const goBack = () => backStep()

  const title = titles[currentStep]

  if (!title) return null

  return (
    <TakeAdvanceHeaderContainer>
      <IconButton
        size="sm"
        onClick={goBack}
        style={{ visibility: showBackButton ? 'visible' : 'hidden' }}
      >
        <ArrowNarrowLeft />
      </IconButton>
      <Typography $bold $size="sm">
        {title}
      </Typography>
      <IconButton size="sm" onClick={close}>
        <X />
      </IconButton>
    </TakeAdvanceHeaderContainer>
  )
}
